import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import ProcessParametersChart from '../cards/ProcessParametersChart'
import ProcessParametersTable from '../cards/ProcessParametersTable.vue'
import './ProcessParameters.less'
import dayjs from 'dayjs';
import { exportParameters } from '@/api/api';

@Component({
  components: {
    ProcessParametersChart,
    ProcessParametersTable
  }
})
export default class TimeAnalysisBody extends Vue {
  @Prop({ default: () => ([]) }) tabsdData: Array<any>
  @Prop({ default: () => ([]) }) data: Array<any>
  @Prop({ default: () => ([]) }) process: Array<any>
  @Prop({ default: false }) loading: Boolean
  showType: String = 'bar'
  showDoaing: Boolean = false
  defaultActiveKey = 0
  modal1Visible: Boolean=false
  checkListids=[]
  exportList=[]

  chartBody() {
    if (this.showType === 'bar') {
      return (
        <a-row>
          { this.data.map(item => {return this.chartLine(item)}) }
        </a-row>
      )
    } else {
      return (<process-parameters-table dataValue={ this.data }></process-parameters-table>)
    }
  }

  chartLine(item){
    return (
      <a-col span={24} style="padding-left:16px;">
        <div class="process-parameters-title">
          { item.paramDesc }
        </div>
        <div style="width:100%;height:340px;overflow:auto;margin-bottom:8px;">
          {(item.finalEndList && item.finalEndList.length > 0) ? <process-parameters-chart unit={item.unit} dataName={item.paramDesc} dataValue={ item.finalEndList } data={this.data}></process-parameters-chart> : this.emptyHtml() }
        </div>
      </a-col>
    )
  }

  emptyHtml(){
    return (
      <div style="width: 100%; height:340px; display: flex; justify-content: center; align-items: center;">
        <wm-empty text={this.$t('page_wm_empty')} />
      </div>
    )
  }

  handleShowTypeChange(value) {
    this.showType = value
    this.$emit('showTypeChange',(value === 'bar') ? 1 : 2)
  }

  changeTabs(value) {
    this.defaultActiveKey = value
    this.$emit('changeTabs',value)
  }

  callback(val) {
    console.log(val);
  }

  renderLoading() {
    return (
      <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 34px" spin />
        </a-spin>
      </div>
    )
  }
  organizeData(item) {
    const arr = item.split("~")
    const year = dayjs(arr[0]).format('YYYY')
    const day = dayjs(arr[0]).format('YYYY-MM-DD')
    arr[0] = arr[0].replace(year + "-","")
    arr[1] = arr[1].replace(day + " ","")
    const value = arr.join("~")
    return value
  }

  exportHandle() {
    this.$emit('export',this.exportList)
  }
  // 点击导出
  handler() {
    this.$emit('getWork')
    if(this.data.length) {
      this.showDoaing = true
    } else {
      this.$message.error(this.$t('page_no_data_export_or_no_query'))
    }
  }

  // 导出成功
  handleOk() {
    this.showDoaing = false
    this.checkListids.map(id=>{
      if(this.checkListids.length){
      this.process.map(item=>{
        if(item.id==id){
        delete item.iotAppCode
        delete item.paramDescI18nKey
        delete item.iotAppParamId
        delete item.iotCode
        delete item.iotId
        delete item.iotName
        delete item.workStationCode
        delete item.workStationId
        this.exportList.push(item)
        }
      })
      }
    })

    this.exportHandle()
    this.checkListids = []
    this.exportList = []
  }

  cancelHandle() {
    this.showDoaing=false
    this.checkListids=[]
  }

  // 复选框改变
  onChange(ids){
    this.checkListids=ids
  }

  render() {
    return (
      <blank-view>
        <div slot="action" style="display: flex; justify-content: space-between;">
          <div>
            <a-button type="primary" onClick={()=>this.handler()}>{this.$t('page_product_export')}</a-button>
            <a-modal
            title={this.$t('page_product_export')}
            visible={this.showDoaing}
            closable
            okText={this.$t('page_product_export')}
            onOk={()=>this.handleOk()}
            onCancel={()=>this.cancelHandle()}

            >
              <a-checkbox-group value={this.checkListids}  onChange={(e)=>this.onChange(e)}>
              <a-row class="checked-modle">
              {this.process.length>0?this.process.map(item=>{
                return <a-col span={8}><a-checkbox value={item.id}>{item.paramDesc}</a-checkbox></a-col>
               }):null
               }
              </a-row>
               </a-checkbox-group>
            </a-modal>
          </div>
          <div style="display: flex; justify-content: flex-end;">
            <a-radio-group value={this.showType} onChange={data => this.handleShowTypeChange(data.target.value)}>
              <a-radio-button value="bar">
                { this.$t('page_operation_statistics_linechart') }
              </a-radio-button>
              <a-radio-button value="table">
                { this.$t('page_operation_statistics_tablechart') }
              </a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <div style="height:100%">
          <div style="width: 100%">
            <a-tabs
              active-key={this.defaultActiveKey}
              tab-position={'top'}
              onPrevClick={this.callback}
              onNnextClick={this.callback}
              tabBarGutter={4}
              onChange={value => this.changeTabs(value)}
            >
              {this.tabsdData.length > 0 ? this.tabsdData.map((res,index) =>{return (<a-tab-pane key={index} tab={this.organizeData(this.tabsdData[index])}></a-tab-pane>)}) : null}
            </a-tabs>
          </div>
          <div class="process-parameters-content">
            {this.loading ? this.renderLoading() : this.data.length > 0 ? this.chartBody() : <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"><wm-empty text={this.$t('page_wm_empty')} /></div>}
          </div>
        </div>

      </blank-view>
    )
  }



}
